import { Component, OnInit, Input, EventEmitter, Output, ViewChild, ElementRef, Inject } from '@angular/core';
import { forumdetails } from 'src/app/models/forum';
import { Router, ActivatedRoute, Params } from '@angular/router';
import { ForumService } from '../../services/forum.service'
import { ToastrService } from 'ngx-toastr';
import { HttpErrorResponse } from '@angular/common/http';
import { DomSanitizer } from '@angular/platform-browser';
import { UseraccessserviceService } from 'src/app/services/useraccessservice.service';
import { PageScrollService } from 'ngx-page-scroll-core';
import { DOCUMENT } from '@angular/common';
@Component({
  selector: 'app-forumtemplate',
  templateUrl: './forumtemplate.component.html',
  styleUrls: ['./forumtemplate.component.css']
})
export class ForumtemplateComponent implements OnInit{
  question: forumdetails;
  parent: forumdetails;
  pageid: number;
  thumbnail: any;
  //currentuserid: number;
  moduleid: number;
  //document: Document;
  ismoduleuser: boolean;
  userid: any;
  currentUserId: number;
  formattedNoOfReplies: string;
  questionTextUpdate: string;
  @Input() set data({ question, pageid, moduleid }) {
    this.question = question;
    this.formattedNoOfReplies = this.question.noOfReplies + ' Repl' + (this.question.noOfReplies === 1 ? 'y' : 'ies');
    this.pageid = pageid;
    this.moduleid = moduleid;
    console.log(parent)
  }
  @Output() deleteComment: EventEmitter<number> = new EventEmitter();
  @Output() clearcommenttextarea: EventEmitter<any> = new EventEmitter();
  @Output() replyClicked: EventEmitter<any> = new EventEmitter();
  @ViewChild('chatForm') chatForm: ElementRef;
  @ViewChild('chatFormTextField') chatFormTextField: ElementRef<HTMLInputElement>;
  constructor(private router: Router, private forumservice: ForumService, private toastr: ToastrService, private sanitizer: DomSanitizer, private user: UseraccessserviceService, private pageScrollService: PageScrollService, @Inject(DOCUMENT) private document: any) {
    //this.currentuserid = user.currentUser.id;
  }
  
  async ngOnInit() {
    if (this.question.quoteID > 0) {
      this.getdiscussions(this.question.moduleID, this.question.quoteID, this.question.quoteID);
    }
    
    this.userid = this.question.userId;
    this.user.getuserprofileimage(this.userid).subscribe((imageurl: any) => {
      //alert(JSON.stringify(data.image));
      //let objectURL = 'data:image/jpeg;base64,' + baseImage;

      // this.thumbnail = this.sanitizer.bypassSecurityTrustUrl(baseImage);
      this.thumbnail = imageurl.url;

    });

    this.forumservice.isModuleUser(this.question.userId,this.question.moduleID).subscribe((isadmin: any) => {
      this.ismoduleuser = isadmin;
    });

    this.pageScrollService.scroll({
      document: this.document,
      scrollTarget: '.theEnd',
    });

    const currentUser = await this.user.getuserprofile(0).toPromise();
    this.currentUserId = currentUser.id;
  }
  forumdetails(parentcommentid: string) {
    this.clearcommenttextarea.emit(true);
    this.replyClicked.emit(true);
    this.router.navigate(['user/forum'], { queryParams: { 'moduleid': this.moduleid, 'parentcommentid': parentcommentid } })
  }

  update(comment: forumdetails) {
    this.questionTextUpdate = this.questionTextUpdate.trim();
    if (this.questionTextUpdate == "") {
      if (comment.quoteID == 0)
        this.toastr.error("Comment/Question Cannot Be Blank");
      else
        this.toastr.error("Reply Cannot Be Blank");
    }
    else {
      comment.text = this.questionTextUpdate;
      this.forumservice.addquestion(comment).subscribe(
        (data: any) => {
          console.log(data);
          // this.urlSubsription();
          //this.newquestion = new forumdetails();
        },
        (error: HttpErrorResponse) => {
          if (error.status === 0) {
            console.log("Unable to connect to server");
          }
          else if (error.status === 400) {
            console.log(error.error.message);
          }
        }
      );
    }
    this.canceledit();
  }

  delete(id: number) {
    // this.forumservice.deletequestionById(id).subscribe(
    //   (data: any) => {
    //     console.log(data);
    //     //this.urlSubsription();
    //     // this.newquestion = new forumdetails();
    //   },
    //   (error: HttpErrorResponse) => {
    //     if (error.status === 0) {
    //       console.log("Unable to connect to server");
    //     }
    //     else if (error.status === 400) {
    //       console.log(error.error.message);
    //     }
    //   }
    // );  
    this.deleteComment.emit(id);

  }

  dislike(id: number) {
    //update dislike
    //udate lastupdated date 
  }
  like(id: number) {
    //update like
    //udate lastupdated date 
  }
  getdiscussions(moduleid: number, parentid: number, commentid: number) {
    this.forumservice.getCommentsById(parentid, moduleid, commentid).subscribe(f => {
      this.parent = f[0];
      
      console.log("Parent on template" + this.parent);
    });
  }

  edit() {
    this.questionTextUpdate = this.question.text;
    this.chatForm.nativeElement.style.display = 'block';
    this.chatFormTextField.nativeElement.focus();
    setTimeout(() => this.chatFormTextField.nativeElement.select(), 0);
  }

  canceledit() {
    this.chatForm.nativeElement.style.display = 'none';
  }
}
